/**
 * 英文
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "Chinese",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "English",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "Chinese traditional",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "Japanese",
			langimg: "../assets/zg.png"
		},

		{
			type: "Vietnamese",
			name: "Vietnamese",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "Malay",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "Hindi",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "Thai",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "Russian",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "Indonesian",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "english",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "Home",
		activity: "Activity",
		to_promote: "Extension",
		help: "Help",
		my: "My"
	},
	// 提示
	prompt: {
		verification: "Verification code error",
		account: "Account number 8-20 digits, pure numbers or letters",
		password: "Password greater than or equal to 6 digits + letters or character combination",
		two: "The two passwords are inconsistent",
		yizhi: 'Password and account cannot be the same',
		successful: "login was successful",
		loginsuccessful: "Login successful",
		null: "Account password cannot be empty",
		Binding: "Binding succeeded",
		buzhengque: 'The address format is incorrect',
		address: "Please fill in the address",
		Please_choose: "Please select one item first and enter the bet amount",
		Bet_type: "Please select the bet type first",
		success: "Bet successful",
		complete_password: "Please enter the complete password",
		copy_success: "Copied to clipboard",
		copy_fail: "copy failed",
		Set_success: "Set successfully",
		Set_password: "Please set a 6-digit password, which cannot contain ‘letters, matches and spaces’",
		update_success: "Modified successfully",
		input_number: "Please enter quantity",
		addressvalue: "Please select wallet address"
	},
	head: { //头部
		luckyhash: "Hash bet",
		address: "Bind wallet address",
		history: "Betting history",
		help: "help",
		lotteryRecord: "Lottery record",
		notice: "Announcement list",
		question: "common problem",
		performance: "reward",
		add_address: "Add Wallet",
		asset: "Asset password",
		balance: "Details",
		exchangeRecord: "exchange",
		forrecord: "Exchange record",
		language: "Language settings",
		update_assets_password: "Modify asset password",
		update_login_password: "Modify login password",

		myteam: "My team",
		recharge: "Balance recharge",
		setting: "set up",
		transactiondetails: "Betting record",
		transfer: "Commission transfer",
		user: "Personal Center",
		userInfo: "personal data",
		withdrawal: "Withdrawal",
		commission: "Commission withdrawal",
		withdrawalRecord: "Withdrawal record",
		top_up: "Recharge record"
	},
	withdrawalRecord: {
		Select_month: "Select month",
		afterPrice: "balance",

	},
	withdrawal: {
		withdrawalrecord: "Withdrawal record",
		commission: "Cashable assets",
		number: "Quantity to transfer",
		withdrawal_number: "Withdrawal quantity",
		money_address: "Wallet address",
		addressvalue: "Please select the wallet address",
		poundage: "Service Charge",
		immediately: "Immediate withdrawal",
		Warm_prompt: "Warm tip: Please fill in the correct wallet address, otherwise you cannot withdraw money. Once the withdrawal wallet address is filled in and bound, it cannot be modified. If you need to modify it, please contact customer service",
		input_password: 'Please enter the asset password',
		betting: "Bet",

	},
	userInfo: {
		Head_portrait: "Personal Avatar",
		account: "account number",
		Choose_picture: "Select Avatar",
		cancel: "cancel",
		determine: "determine"
	},
	user: {
		wallet_account: "Wallet account",
		balance: "Details",
		top_up: "Recharge",
		withdrawal: "withdraw",
		my_wallet: "My wallet",
		add_wallet: "Add Wallet",
		look: "View records",
		look_all: "See more",
		Pack_up: "Put away",
		For_record: "Exchange record",
		bettingRecord: "Transaction details",
		reward: "Promotion reward",
		goCustomerLink: "Online Service",
		Commission_account: "Commission account",
		transfer: "transfer",
		number: "Betting data",
		transactiondetails: "View details",
		day: "Bet today",
		day_winning: "Win today",
		my_team: "My team",
		about_we: "About us",
		center: "Customer service center",
		setting: "set up",
		delete: 'delete',
		isDelete: "Confirm to delete Wallet"
	},
	transfer: {
		money: "Commission balance",
		account_balance: "Account balance",
		number: "Quantity to transfer",
		select: "Please select",
		Immediately_transfer: "Immediate transfer",
		password: "Please enter the asset password",
		betting: "Bet",

	},
	transactiondetails: {
		type: "type",
		input_type: "Please select type",
		date: "date",
		select_date: "Please select a date",
		select: "query",
		bettingmoney: "Bet amount",
		winning_amount: "Winning amount",
		time: "time",
		not: "no data",
		noopen: 'Not yet open',
		B1: 'Lucky hash-Lucky size',
		B2: 'Lucky hash-Lucky combination',
		B3: 'Lucky hash-Lucky Dragon and tiger',
		B4: 'Lucky hash-Lucky Zhuang Xian',
		B5: 'Lucky hash-Lucky number',
		A1: 'Casino - Lucky Racing',
		A2: 'Casino - Lucky Speedboat',
		A3: 'Casino - Lucky Horse Racing',
		A4: 'Casino - Lucky Size',
		A5: 'Casino - Lucky Combo',
		A6: 'Casino - Lucky Dragon Tiger',
		A7: 'Casino - Lucky Zhuang Leisure',
		A8: 'Casino - Lucky Array',
		options: [{
			value: "Lucky hash - double sided",
			label: "B1",
		},
		{
			value: "Lucky hash - combination",
			label: "B2",
		},
		{
			value: "Lucky hash - Dragon Tiger combination",
			label: "B3",
		},
		{
			value: "Lucky hash - Baccarat",
			label: "B4",
		},
		{
			value: "Lucky hash - alone courage",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "Modify login password",
		assets_pwd: "Asset password",
		not: "Not set",
		yes: "Set",
		language: "Language settings",
		exit: "sign out",

	},
	recharge: {
		recharge_code: "Recharge record",
		Chain_type: "Chain type",
		address: "Recharge address",
		copy_address: "Copy address",
		remind: "Operation reminder",
		content: "Content content content content content content",
		copy_success: 'Copy successful'
	},
	myteam: {
		select: "query",
		time: "date",
		money: "Day Commission",
		people: "Number of direct subordinates",
		team: "team",
		zsxx: "Please enter the uid to view the direct player information",
		zsyj: 'Direct performance',
		tdyj: 'Team performance',
		jryj: 'Today',
		jrsy: 'Earnings today',
		ljsy: 'cumulative income',
		friendsCategoryList: ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5'],
	},
	announcement: {
		title: 'Latest Announcement',
		close: 'close',
	},
	login: {
		order_password: "Old password",
		input_ordpwd: "Please enter your old password",
		new_pwd: "New password",
		number: "Please set 6-16 upper and lower case letters + numbers",
		six_pwd: "Please enter a 6-digit password",
		confirmPassword: "Confirm password",
		confirm: "confirm",
	},
	forrecord: {
		spending: "Exchange expenses",
	},
	exchangeRecord: {
		exchangeRecord: "exchange",
		record: "record",
		For_spending: "Exchange expenses",
		money: "Exchange amount",
		exchange_number: "Exchange quantity",
		number: "quantity",
		market_price: "Market price",
		Miners_fee: "Miner's fee",
		input_money: "Please enter the exchange amount",
		Get_the_amount: "Amount obtained",
		Can_be: "Available amount",
		address: "Wallet address",
		Immediatelychange: "Redeem now",
		Warm_prompt: "reminder",
		details: "Particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars particulars"
	},
	balance: {
		balance_of: "balance",
		data: "date",
		dataPickerRange: "Please select",
		select: "query",
		to: 'to'
	},
	asset: {
		password: "Please set a 6-digit password, which cannot contain 'letters, matches and spaces'",
		confirm: "confirm",
	},
	add_address: {
		money_address: "Please enter wallet address (trc20)",
		save: "preservation"
	},
	spread: {
		cumulative: "Your cumulative invitation",
		people: "people",
		make: "Earned",
		Continue_to: "Continue to strive for the grand prize",
		url: "Share links",
		Friends_registered: "Friend registration",
		money: "Link Wallet",
		Friends_deal: "Friend transaction",
		copy_url: "Copy link invitation",
		my_group: "My team",
		look: "View performance details",
		directCount: "Number of direct subordinates",
		group: "Number of teams",
		Commission_withdrawal: "Commission withdrawal",
		historyAward: "Historical Commission received",
		yesterdayAward: "Commission yesterday",
		currentAward: "Current commission receivable",
		todayAward: "Today's performance",
		my_invite: "My invitation code",
		copy_invite: "Copy invitation code",
		top_title: "My superior",
		update: "It cannot be modified after the parent is bound",
		nikname: "Please enter the parent nickname to bind",
		binding: "binding",
		Commission_ratio: "commission rate",
		level: "level",
		ratio: "Rebate ratio (betting amount)",
		Directly_under: "Direct subordinate",
		first: "The first",
		levelone: "level",

	},
	performance: {
		datatime: "date",
		pick: "Please select",
		select: "query",
		total: "Total performance today",
		performance: "Performance details",
		directCount: "Number of direct players",
		todayTotalPerformByDirect: "Performance of direct players today",
		other: "Number of other players",
		todayTotalPerformByOther: "Performance of other players",
		Commission_withdrawal: "Commission withdrawal",
		historyAward: "Historical Commission received",
		yesterdayAward: "Commission yesterday",
		currentAward: "Current commission receivable",
		todayAward: "Today's performance",
		Commission_ratio: "commission rate",
		level: "level",
		ratio: "Rebate ratio (betting amount)",
		Directly_under: "Direct subordinate",
		first: "The first",
		levelone: "level",
	},
	lotteryRecord: { //开奖记录
		block: "block",
		highly: "block height",
		results_of: "result",

	},
	help: {
		DAPP: "Participate in the process",
		a: "Copy DAPP game address for usdt-trc20 transfer",
		b: "Open this website in the wallet blockchain browser (TRX network), you can bet on DAPP immediately without copying",
		Focus_on: "Please always pay attention to refreshing our home page to get the latest transaction address.",
		login: "Log in to the official website of wave field to query the block hash value",
		hash: "You can query your block hash value on the official website of wave field",
		you: "You can visit the official website of wave field",
		login_website: "Log in to the official website of wave field",
		query: "Query your block hash value on",
		look: "Click to view the tutorial",
		congratulations: "Congratulations",
		winning: "If you win the prize, the system will return the prize to you within 1 minute",
		address: "If you win the prize, the system will return the prize to your transfer address within 1 minute",
		number: "Purchase usdt and TRX in digital currency exchange",
		skip: "If your wallet already has usdt and TRX, you can skip this step",
		Digital_currency: "Buy usdt and TRX in the digital currency exchange, and then transfer usdt and TRX to your [decentralized wallet]. You can use the wallet registered on the following centralized wallet website:",
		platform: "platform",
		url: "website",
		tutorial: "course",
		vpn: "Friendly tip: if you can't open the telegraph, you can use God VPN",
		vpnurl: "Magic lamp VPN website",
		whirlwind: "Cyclone accelerator website",
		can_login: "You can log in",
		why: "Why choose XXXX",
		most_fair: "Most fair",
		play: "No kicking, no dropping, no interference",
		Publicly_available: "The block hash value is randomly generated, the result is unified, can not be changed, and can be publicly checked",
		security: "Safest",
		no_money: "Working capital can be seen. Don't worry about losing money",
		Cannot: "The transfer records of the owner can be seen and cannot be falsely publicized",
		Visi_convenient: "Most convenient",
		Without_registration: "No need to register, no need to recharge, no need to apply for withdrawal",
		questions: "common problem",
		one: "What is block hash",
		dna: "The block hash value is the DNA of a piece of data. Each block hash value is unique, random and unbreakable。",
		lookintroduce: "Click to view the introduction of Baidu Encyclopedia hash value。",
		what: "What blockchain",
		Block_chain: "In essence, blockchain is a shared database in which data or information is stored. It has the characteristics of non forgery, leaving traces in the whole process, traceability, openness and transparency, collective maintenance and so on。",
		wallet: "Centralized wallet? Decentralized wallet? Why can't the centralized wallet query the transfer？",
		example: "For example, if your wallet address is a and you transfer the address e into 10usdt, but you use the transaction hash value to query, you can only query the transfer between a service provider's random account book address B (or C or D, etc.) and E. Similarly, e cannot know whether these 10 usdts are transferred out by you, because e can only see that it is the account book address B that transfers in 10 usdts to him. This is why the centralized wallet cannot query the real transfer information on the block shoes.",
		why_winning: "Why do I win or not win in a row",
		First: "First of all, it is a small probability event that has not won the prize for many times in a row",
		small: "Definition of small probability events",
		second: "Secondly, winning and not winning are random events, and the frequency of random events will tend to a stable value. In the case of non iteration, the probability of things appearing is equal for everyone. In this case, everyone is fair. At the same time, random events will comply with the law of large numbers (under the condition that the test remains unchanged, repeat the test many times, and the frequency of random events is similar to the definition of the law of large numbers). When the transfer frequency continues to increase, the probability of winning or not winning will tend to a stable value. So please continue to transfer. As the transfer frequency increases, the total probability of winning the prize will increase.",
		whydelay: "Why is it delayed",
		Click_to_view: "Click to view the speed environment of blockchain: <<trust is the most important thing, and it's slow>>",
		six: "Why is there a key when transferring money? Then what is the type option of usdt? Which one should I choose?",
		global: " There are many well-known public chains around the world",
		click_look: "Click to view the introduction of global Zhige public chain",
		how: "When transferring currency, what should I do if I transfer the address or select the wrong currency type? Can I return?",
		For_instance: " For example, when you transfer money to us, you should choose trc20 under USD, but if you choose Omni or usderc20 under other types of USD, you will lose money, which cannot be retrieved.",
		How_to_force: "Click to see what to do if you transfer the wrong currency?",
		Other_problems: "Other issues",
		callwe: "If you have any questions, please contact us",
		immediately: "Bet now",
		company: "Company information",
		link: "Links",
		register: "Registered digital currency decentralized Wallet",
		Already_have: "If you already have a wallet, you can skip this step",
		download: "Download and register a digital currency decentralized Wallet",
		com_title: "Digital currency wallet related website tutorial is as follows"
	},
	register: { //登录注册
		login_tips: "Please reset your login password",
		address: "Please enter wallet address",
		confirm: "Confirm password",
		confirmupdate: "Confirm modification",
		toRegister: "Go register",
		agreement: "Sign in and agree",
		user: "User agreement",
		policy: "Privacy policy",
		welcome: "Welcome to",
		login: "Log in to your account",
		forget: "We look forward to your joining",
		nowLogin: "Sign in",
		nologin: "Don't log in temporarily",
		new: "Create a new account",
		login: "Make it easier for you to make money",
		account: "Account number 8-20 digits, pure numbers or letters",
		password: "Password greater than or equal to 6 digits + letters or character combination",
		confirm_password: "Confirm password",
		inviteCode: "Please enter the invitation code (optional)",
		verificationCode: "Please enter the verification code",
		toRegister: "register",
		noaccount: "No account",
		toLogin: "Go login"
	},
	address: {
		warmprompt: "Warm tip: Please fill in the correct wallet address, otherwise you cannot withdraw money. Once the withdrawal wallet address is filled in and bound, it cannot be modified. If you need to modify it, please contact customer service",
		tips: "Please bind at least one wallet address. You can't retrieve it when you forget your password",
		TRC20: "To avoid input errors, please copy and long press here to paste (trc20)",
		toBind: "Bind now",
		noBind: "Do not bind temporarily",
	},
	luckyhash: { //幸运哈希
		walletName: 'Link',
		exchange: "exchange",
		reward: "reward",
		Customerservice: "Service",
		instructions: "explain",
		luckyhash: "Lucky hash",
		entertainment: "Casino",
		Doublesided: "two-sided",
		odds: "Odds",
		immediately: "Bet now",
		combination: "combination",
		LongHuge: "Dragon Tiger combination",
		baccarat: "Baccarat",
		gallbladder: "Single gall",
		Hashracingcar: "Hash racing",
		Hashspeedboat: "Hashi speedboat",
		Hashracing: "Hash horse racing",
		bothsides: "two sides",
		problem: "common problem",
		all: "See more",
		friend: "cooperative partner"
	},
	history: {
		block: "block",
		type: "type",
		big: "Big",
		highly: "block height",
		results_of: "result"
	},
	entertainment: {
		lastBlock: "Previous block",
		resultValue: "Lottery results",
		currentblock: "Current Block",
		nextBlock: "The lottery block",
		toLotteryRecord: "Lottery record",
		block: "block",
		money1: "amount of money",
		type: "type",
		all: "See more",
		both_sides: "two sides",
		big: "Big",
		small: "Small",
		single: "Odd",
		double: "Even",
		daxiao: 'size',
		champion: "champion",
		yajun: 'runner-up',
		he: 'Tie',
		champion_one_size: "Champion single size",
		crown: "Guanyahe",
		andbig: "Sum Big",
		andsmall: "Sum Small",
		andsingle: "Sum Odd",
		anddouble: "Sum Even",
		championtwo: "Champion two sides",
		combination: "combination",
		forlarge: "big odd",
		smallsingle: "Small odd",
		large_double: "big Even",
		small_double: "Small Even",
		Long_Huge: "Dragon Tiger combination",
		dragon: "Dragon",
		tiger: "Tiger",
		us: "Tie",
		baccarat: "Baccarat",
		zhuang: "banker",
		idle: "Player",
		gallbladder: "Single gall",
		Atotalof: "all",
		note: "stakes",
		Check_the_details: "View details",
		money: "Balance",
		pause: "Select",
		reset: "Reset",
		inputmoney: "Enter",
		submit: "Submit",
		password: "Please enter the transaction password",
		betting: "Bet",
		determine: "determine",
	},
	details: {
		block: "block",
		money: "amount of money",
		type: "type",
		resultValue: "Lottery results",
		all: "See more",
		address: "Betting address",
		toLotteryRecord: "Lottery record",
		money: "Wallet betting",
		copy: "Copy betting address",
		ts: "Please do not use the address of the exchange, otherwise you will not receive the reward",
		USDT: "Please transfer the wave field usdt / TRX (trc20)",
		Betting_amount: "Bet amount",
		inputmoney: "Please enter the betting amount",
		confirm: "confirm",
		cancel: "cancel",
	},
	data: {
		noData: 'No data',
		deleteSuc: 'Deleted successfully',
		iscon: 'Confirm bet?',
		fenpan: 'No betting is allowed during the closing period',
		erweima: 'Save QR code'
	},
	phone: {
		title: 'Bind mobile number',
		phone: 'phone',
		input: 'Please enter the bound mobile phone number',
		code: 'Code',
		inputcode: "Please enter the verification code",
		getCode: 'Get verification code',
		details: 'Please fill in the area code and mobile phone number first',
		success: 'Verification code sent successfully',
		bsuccess: 'Binding succeeded',
		jiaoyi: 'Please set the transaction password first',
		caozuo: "Operation successful",
		touxiang: "Please select a Avatar",
		buzu: 'Sorry, your credit is running low',
		tuiguan: 'Promotion Center',
		qubie: 'Click to view the differences between blockchain wallets',
		yhm: 'Please enter your user name',
		mm: 'Please enter your password',
		xqgg: 'Go and have a look first',
		llwm: 'contact us',
		lj: 'Please connect your wallet first',
		dk: 'Please open it in the wallet app',
		qd: 'We look forward to your joining',
		yjmx: 'Commission details'
	},
	vip: {
		jl: "reward",
		xrjl: 'Newcomer reward',
		ckgz: 'View rules',
		zcsj: 'Registration deposit',
		qbsj: 'Bind mobile phone and wallet address',
		dlq: 'unclaimed',
		qwc: 'To complete',
		ylq: 'Received',
		tgrw: 'Promotion task',
		rwjl: 'Task reward',
		yq: 'invitation',
		ghy: 'Quality friends',
		lqcg: 'Received successfully',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/English.js